export const formColumnsWidth = {
  incidents: '240px minmax(0, 1fr) 60px 160px 220px 24px;',
  dataModelerFieldsEditor:
    '80px minmax(100px, 1fr)  minmax(100px, 1fr)  ' +
    'minmax(100px, 1fr)  minmax(200px, 2fr) 100px 32px 32px 32px 32px',
};
